<template>
  <div class="pulsate" @mousemove="handleMouseMove">
        <table id="ls-table">
          <colgroup>
            <col style="width: 12%;">
            <col style="width: 5%;">
            <col style="width: 10%;">
            <col style="width: 10%;">
            <col style="width: 10%;">
            <col style="width: 18%;">
            <col style="width: 35%;">
          </colgroup>
          <tr><td>total 6872</td></tr>
          <tr><td>dxwrx-rx-r  </td><td>13</td> <td>catalyst</td> <td>staff</td>  <td>    442</td> <td>Dec 24 18:57</td> <td>AI</td></tr>
          <tr><td>dxwrx-rx-r  </td><td>12</td> <td>catalyst</td> <td>staff</td>  <td>    408</td> <td>Dec  6 11:51</td> <td>algorithms</td></tr>
          <tr><td>-rw-r--r--@ </td><td> 1</td> <td>catalyst</td> <td>staff</td>  <td>1525156</td> <td>Jan  1 18:13</td> <td><a href="http://en.wikipedia.org/wiki/Go_%28game%29" target="new">go</a></td></tr>
          <tr><td>-rw-r-----@ </td><td> 1</td> <td>catalyst</td> <td>staff</td>  <td>{{timerLive}}</td> <td>Sep 29 23:19</td> <td>dqn-8x400x300x5.tsv</td></tr>
          <tr><td>-rw-r-----@ </td><td> 1</td> <td>catalyst</td> <td>staff</td>  <td>{{xyLive}}</td> <td>Sep 28 19:30</td> <td>h2o2.tsv</td></tr>
          <tr><td>-rw-r--r--  </td><td> 1</td> <td>catalyst</td> <td>staff</td>  <td>   1419</td> <td>Jan  3 13:26</td> <td><a href="https://www.linkedin.com/in/anuzis" target="new">linkedin</a></td></tr>
          <tr><td>-rw-r-----@ </td><td> 1</td> <td>catalyst</td> <td>staff</td>  <td>  71108</td> <td>Nov 20 22:08</td> <td><a href="/maxims/">maxims</a></td></tr>
          <tr><td>-rw-r--r--@ </td><td> 1</td> <td>catalyst</td> <td>staff</td>  <td> 141390</td> <td>Dec 30 12:13</td> <td><a href="http://www.amazon.com/Road-Less-Traveled-Timeless-Edition/dp/0743243153" target="new">road less travelled</a></td></tr>
          <tr><td>-rw-r-----@ </td><td> 1</td> <td>catalyst</td> <td>staff</td>  <td>{{typedLive}}</td> <td>Jan  3 13:22</td> <td><a href="https://twitter.com/anuzis" target="new">twitter</a></td></tr>
          <tr><td>-rw-rw-r--  </td><td> 1</td> <td>catalyst</td> <td>staff</td>  <td>   1770</td> <td>Sep 22 23:34</td> <td>watersheds.py</td></tr>
        </table>
  </div>
</template>

<script>
export default {
  name: 'DirectoryTable',
  props: ['typedLive'],
  data() {
    return {
      xyLive: 75073,
      timerLive: 5257910,
      timer: null,
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.timerLive += parseInt(Math.random() * 2000)
    }, 800)
  },
  methods: {
    handleMouseMove(e) {
        this.xyLive = parseInt(this.xyLive + (e.offsetX / 50))
        this.yyLive = parseInt(this.yyLive + (e.offsetY / 50))
    },
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
